module.exports = __webpack_public_path__ + "media/images/challenges/golden-ticket-22/2014_professional_winner-618ea80884b90f0381f7a6634ac2e09b.jpg";